import React, { useState, useEffect } from "react";
import Grid from "./Grid";
import GridForm from "./GridForm";
import ArrowGrid from "./ArrowGrid";
import AllWords from "./AllWords";
import axios from "axios";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function WordHuntSolver() {
  const [letters, setLetters] = useState("");
  const [directions, setDirections] = useState([]);
  const [currWord, setCurrWord] = useState(null);
  const [currIdx, setCurrIdx] = useState(0);
  const [size, setSize] = useState(4);
  const [allDirections, setAllDirections] = useState([]);

  const url = "https://gamepigeon.pythonanywhere.com";
  // const proxyurl = "https://cors-anywhere.herokuapp.com/";
//   const url = "http://127.0.0.1:5000";
  // const url = "http://8408b4828030.ngrok.io";
  // handles the solve with the grid
  function handleSolveLetters(letters) {
    if (letters != "") {
      setLetters(letters);
      axios
        .post(`${url}/wordhunt`, {
          letters: letters,
          size: size,
        })
        .then(
          (response) => {
            setAllDirections(response.data.answer);
          },
          (error) => {
            console.log(error);
          }
        );
      setCurrIdx(0);
    }
  }

  useEffect(() => {
    if (letters != "" && allDirections != []) {
      setDirections(allDirections[currIdx][1]);
      setCurrWord(allDirections[currIdx][0]);
      setCurrIdx(currIdx + 1);
      // document.getElementsByName("next")[0].style.display = 'block';
    }
  }, [allDirections]);

  const handleClick = (data) => {
    // setLetters(data);
    handleSolveLetters(data);
  };
  const handleNext = () => {
    if (letters != "") {
      setDirections(allDirections[currIdx][1]);
      setCurrWord(allDirections[currIdx][0]);
      setCurrIdx(currIdx + 1);
    }
  };
  return (
      <div>
        <Row>
          <Col md="6">
            <h3 className="text-center">Enter your letters</h3>
            <GridForm
              onClick={handleClick}
              nextClick={handleNext}
              currWord={currWord}
              size={size}
              letters={letters}
            />
          </Col>

          <Col md="6">
            <div className="parent px-1">
              <Grid letters={letters} />
              <div className="child">
                <ArrowGrid directions={directions} size={size} />
              </div>
            </div>
          </Col>
        </Row>
        <div className="mt-3">
          <AllWords words={allDirections} />
        </div>
      </div>
  );
}

export default WordHuntSolver;
